module.exports = __webpack_public_path__ + "static/alter-ceiling.6edf0293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alter-ceiling.jpg
// module id = 90
// module chunks = 35783957827783 82680274759079